import { useCallback, useEffect, useState } from 'react';
import { couponsService } from './coupons.service';
import { getErrorMessage } from './coupons.utils';

const PAGE_SIZE = 10;

export function useCouponsAdmin() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');
  const [discountType, setDiscountType] = useState('');
  const [appliesTo, setAppliesTo] = useState('');
  const [sortBy, setSortBy] = useState('validUntil');
  const [sortDir, setSortDir] = useState('DESC');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPage = useCallback((overrides = {}) => {
    setIsLoading(true);
    setError(null);
    const nextPage = overrides.page ?? page;
    const params = {
      page: nextPage,
      pageSize: PAGE_SIZE,
      search: search || undefined,
      status: status || undefined,
      discountType: discountType || undefined,
      appliesTo: appliesTo || undefined,
      sortBy,
      sortDir,
    };
    return couponsService
      .listCouponsAdmin(params)
      .then((data) => {
        setItems(data.items);
        setTotal(data.total);
        setPage(data.page);
      })
      .catch((err) => {
        setError(getErrorMessage(err, 'Could not load coupons.'));
      })
      .finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, search, status, discountType, appliesTo, sortBy, sortDir]);

  useEffect(() => {
    fetchPage({ page: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, status, discountType, appliesTo, sortBy, sortDir]);

  const goToPage = (nextPage) => fetchPage({ page: nextPage });

  const toggleSort = (field) => {
    if (sortBy === field) {
      setSortDir((d) => (d === 'ASC' ? 'DESC' : 'ASC'));
    } else {
      setSortBy(field);
      setSortDir('ASC');
    }
  };

  const resetFilters = () => {
    setSearch('');
    setStatus('');
    setDiscountType('');
    setAppliesTo('');
  };

  return {
    items,
    total,
    page,
    pageSize: PAGE_SIZE,
    isLoading,
    error,
    search,
    setSearch,
    status,
    setStatus,
    discountType,
    setDiscountType,
    appliesTo,
    setAppliesTo,
    sortBy,
    sortDir,
    toggleSort,
    goToPage,
    resetFilters,
    refetch: () => fetchPage({}),
  };
}
